import React, { useState, useEffect } from 'react';
import { track } from '@fff-web/fff-analytics';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { getProductReviews } from '../services/api/questionnaire';
import { segmentEnum } from '../utils/segment';

import PageContainer from '../shared-components/PageContainer/PageContainer';
import RateAndReviewHeader from './RateAndReviewHeader/RateAndReviewHeader';
import ProductList from './ProductList/ProductList';
import RateAndReviewEmpty from './RateAndReviewEmpty/RateAndReviewEmpty';

import styles from './styles.module.scss';

const RateAndReview = () => {
  const [products, setProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const { rateAndReviewMaxPurchaseDate: rateAndReviewMaxPurchaseDateFF } =
    useFlags();

  useEffect(() => {
    const fetchProductReviews = async () => {
      try {
        const { data } = await getProductReviews(
          rateAndReviewMaxPurchaseDateFF
        );
        setProducts(data.items);
      } catch (error) {
        setProducts([]);
        // eslint-disable-next-line no-console
        console.error(error);
      } finally {
        setLoadingProducts(false);
      }
    };
    fetchProductReviews();
  }, [rateAndReviewMaxPurchaseDateFF]);

  useEffect(() => {
    if (products.length) {
      track({
        trackName: segmentEnum.rateAndReview,
        properties: {
          products_available: products.length,
        },
      });
    }
  }, [products.length]);

  const renderContent = () => {
    if (loadingProducts) return null;
    if (products.length) return <ProductList products={products} />;
    return <RateAndReviewEmpty />;
  };

  return (
    <PageContainer>
      <div className={styles.container}>
        <RateAndReviewHeader />
        {renderContent()}
      </div>
    </PageContainer>
  );
};

export default RateAndReview;
